import StockReportPage from "./StockReportPage";

export {StockReportPage}
export default StockReportPage
